/* El lápiz: una pantalla se mira, y para tocarla hay que decir que la vas a tocar.
 *
 * QUÉ RESUELVE. Las pantallas del hub que dejan corregir lo hacían siempre: el
 * campo estaba vivo desde que abrías, así que un clic de más sobre una fecha ya
 * era una edición. En una tabla de 210 filas que se recorre buscando a alguien,
 * eso pasa — y lo peor es que no falla: se guarda, queda firmado con tu nombre,
 * y nadie se entera hasta que el dato hace falta.
 *
 * Y ES LA MISMA PIEZA PARA TODAS. Documentación, tractores, furgones, personas.
 * Copiado en cada una, el día que se agregue una confirmación o un aviso habría
 * que acordarse de cuatro lugares — y el que se olvide queda editando de una,
 * que es justo lo que esto viene a cerrar.
 *
 * NO ES EL PERMISO, ES EL MODO. Quien no tiene el permiso de escritura no ve el
 * botón; quien lo tiene decide cuándo. Y lo que de verdad restringe sigue
 * estando en la base: esconder un botón nunca fue una pared. Misma regla que el
 * borrado de tickets.
 *
 * SE DICE QUE ESTÁ PRENDIDO, y no sólo en el botón. Con veinte columnas
 * iguales, la diferencia entre mirar y editar tiene que verse de reojo — por
 * eso la pantalla se marca entera (`.editando`) y no sólo el lápiz.
 */
/* «de» + «el padrón…» se dice «del padrón…»: la pantalla pasa su `que` con el
 * artículo («el pañol», «los trabajos») y acá se contrae. Sólo «el» como
 * palabra entera: «elementos» queda como está. */
const deQue = (que) => (/^el\s/i.test(que) ? `del ${que.slice(3)}` : `de ${que}`);

const ModoEdicion = ({ activo, onCambiar, puede, que = "esta pantalla" }) => {
  /* Sin permiso no se dibuja NADA, ni deshabilitado. Un botón apagado invita a
   * preguntarse qué falta; lo que falta es un permiso, y eso se pide en otro
   * lado. La pantalla ya se abre en sólo lectura, que es la respuesta. */
  if (!puede) return null;

  return (
    <button
      type="button"
      className={"modo-edicion" + (activo ? " activo" : "")}
      onClick={() => onCambiar(!activo)}
      aria-pressed={activo}
      title={
        activo
          ? `Terminar de editar ${que}`
          : `Habilitar la edición ${deQue(que)}`
      }
    >
      <span aria-hidden="true">{activo ? "✓" : "✎"}</span>
      {activo ? "Terminar" : "Editar"}
    </button>
  );
};

export default ModoEdicion;
